<ebb-contractor-search 
    [openOption]="'default'"
    [isPortal]="false"
    [genericLogo]="this.genericLogo"
    [businessLogoRoot]="this.businessLogoRoot"
 ></ebb-contractor-search>
 <!-- [appZIP]="90210"
 [contractorSearchDistance]="25"
 [contractorSearchPhrase]="'steve'"
 [dwellingLat]="38.580104"
 [dwellingLong]="-121.496007"
 [contractorSearchFilterHide]="'zip'" -->